import React, { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Box, constants, TextArea } from '@match/react-component-library';

const { SPACE } = constants;

interface QuestionTextAreaProps {
  onQuestionAdd: (question: string) => void;
  questionText: string;
}

export const QuestionTextArea: FunctionComponent<QuestionTextAreaProps> = ({
  onQuestionAdd,
  questionText,
}) => {
  const intl = useIntl();
  return (
    <React.Fragment>
      <Box marginBottom={SPACE.SMALL}>
        <FormattedMessage {...messages.questionHeader} />
      </Box>
      <div>
        <TextArea
          placeholder={intl.formatMessage(messages.questionTextAreaPlaceholder)}
          value={questionText}
          onChange={(e) => onQuestionAdd(e.target.value)}
          height={250}
          width="100%"
          maxLength={1000}
        />
      </div>
    </React.Fragment>
  );
};

const messages = defineMessages({
  questionHeader: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/QuestionTextArea/QuestionTextArea:questionHeader',
    description: 'category section header',
    defaultMessage: 'Question',
  },
  questionTextAreaPlaceholder: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/QuestionTextArea/QuestionTextArea:questionTextAreaPlaceholder',
    description: 'placeholder text for question text area',
    defaultMessage: 'Add question',
  },
});
